/**
 *@date  2019-11-22
 *@author calong@linewell.com
 *@desc 请求封装
 * url api名称
 * parameter 请求参数
 ***/
import api from './index'
import {axios} from '@/utils/request'
import Vue from 'vue'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import moment from 'moment'

// post 请求 postAxios
export function postAxios (url, parameter, otherParams) {
  const baseParams = {
    url: api[url] || '',
    method: 'post',
    data: parameter || {},
    params: otherParams || {}
  }

  return axios(baseParams)
}

// get 请求 getAxios
export function getAxios (url, parameter) {
  const baseParams = {
    url: api[url] || '',
    method: 'get',
    params: parameter || {}
  }
  return axios(baseParams)
}

// 导出excel 使用 eg. getExcel('peakDataAnalysisExcel', param)
export function getExcel (url, param) {
  param.token = Vue.ls.get(ACCESS_TOKEN)
  window.location.href = process.env.VUE_APP_BASE_URL + api[url] + getQueryString(param)
}

// 导出excel 使用 eg. getExcelNlinks('peakDataAnalysisExcel', param)
export function getExcelNlinks (url, param) {
  param.token = Vue.ls.get(ACCESS_TOKEN)
  window.location.href = 'http://www.nlinks.cn/zlpt' + api[url] + getQueryString(param)
}

export function getExcelFromJava(url, param) {
  window.location.href = process.env.VUE_APP_BASE_URL + api[url] + getQueryString(param)
}

export function toDateStr(val, formatString = 'YYYY-MM-DD') {
  return formatDate(val, formatString)
}

export function toDateTimeStr(val, formatString = 'YYYY-MM-DD HH:mm:ss') {
  return formatDate(val, formatString)
}

export function formatDate(val, formatString) {
  if (moment(val).isValid()) {
    return moment(val).format(formatString)
  }

  return ''
}

function getQueryString (param) {
  var str = ''
  if (param != null) {
    str = '?'
    for (var key in param) {
      str += key + '=' + encodeURIComponent(param[key]) + '&'
    }
    str = str.substring(0, str.length - 1)
  }
  return str
}



// WEBPACK FOOTER //
// ./src/api/request.js